"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronWidget = void 0;
var react_1 = __importDefault(require("react"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var styles = __importStar(require("./ChevronWidget.css"));
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var ChevronWidget = function (_a) {
    var _b;
    var attributes = _a.attributes, onClick = _a.onClick, children = _a.children, style = _a.style;
    var iconColor = (0, ColorUtils_1.shouldUseDarkText)(style.backgroundColor.value) ? tokens_1.palette.midnight900 : tokens_1.palette.white;
    return (react_1.default.createElement("button", __assign({}, attributes, { className: styles.wrapper, onClick: onClick }),
        react_1.default.createElement(icons_1.ChevronDown, { style: __assign({ width: "1em", height: "1em" }, (0, dynamic_1.assignInlineVars)((_b = {}, _b[kaleidoscope_1.iconVars.color] = iconColor, _b))) }),
        children));
};
exports.ChevronWidget = ChevronWidget;
